(function ($) {
    $(document).on("click", ".post-wrap .blog-landing .filter-nav .filter-inner.sort-div > ul > li > ul > li", function () {
        var text = $(this).text();
        $(this).parents(".filter-inner").find("span").text(text);
        $('.post-wrap .blog-landing .filter-nav .filter-inner.sort-div > ul > li > ul > li').removeClass('active');
        $(this).addClass("active");
    });

    $(window).on("load", function () {
        $(".blog-reference-slider").removeClass('hide-section');
    });
})(jQuery);